import { useState, useEffect } from "react";

interface WindowSize {
  width: number;
  height: number;
}

/**
 * A custom hook that provides the current size of the window.
 *
 * @returns {WindowSize} An object containing the width and height of the window.
 *
 * @example
 * const { width, height } = useWindowSize();
 * console.log(`Width: ${width}, Height: ${height}`);
 */
const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
